import request from '@/utils/request'
import URL from '@/api/urlTranslator'

// 查询列表
export function query(requestBody) {
  return request({
    url: URL.finance.statementDescription.query,
    method: 'post',
    data: requestBody
  })
}

// 查询详情
export function detail(requestBody) {
  return request({
    url: URL.finance.statementDescription.detail,
    method: 'post',
    data: requestBody
  })
}

// 初始化报表
export function initialize(data) {
  return request({
    url: URL.finance.statementDescription.initialize,
    method: 'post',
    data
  })
}

// 报表2
export function getStatement2(data) {
  return request({
    url: URL.finance.statementDescription.getStatement2,
    method: 'post',
    data
  })
}

// 美国财报
export function getStatement2UsaReport(data) {
  return request({
    url: URL.finance.statementDescription.getStatement2UsaReport,
    method: 'post',
    data
  })
}
